export default __webpack_public_path__ + "static/media/arrow-diagonal-up.77580490.svg";